import { Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  Additional: {
    paddingTop: '0.5rem',
  },
}));

export default useStyles;
